import {
  Delete20Regular,
  Edit20Regular,
} from "@fluentui/react-icons";
import React from "react";

// Custom Change icon SVG component
const ChangeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 3.75V11.875C17.5 12.2065 17.3683 12.5245 17.1339 12.7589C16.8995 12.9933 16.5815 13.125 16.25 13.125H7.75859L8.56719 13.9328C8.62526 13.9909 8.67132 14.0598 8.70275 14.1357C8.73417 14.2116 8.75035 14.2929 8.75035 14.375C8.75035 14.4571 8.73417 14.5384 8.70275 14.6143C8.67132 14.6902 8.62526 14.7591 8.56719 14.8172C8.50912 14.8753 8.44018 14.9213 8.36431 14.9527C8.28844 14.9842 8.20712 15.0003 8.125 15.0003C8.04288 15.0003 7.96156 14.9842 7.88569 14.9527C7.80982 14.9213 7.74088 14.8753 7.68281 14.8172L5.80781 12.9422C5.7497 12.8841 5.7036 12.8152 5.67215 12.7393C5.6407 12.6635 5.62451 12.5821 5.62451 12.5C5.62451 12.4179 5.6407 12.3365 5.67215 12.2607C5.7036 12.1848 5.7497 12.1159 5.80781 12.0578L7.68281 10.1828C7.80009 10.0655 7.95915 9.99965 8.125 9.99965C8.29085 9.99965 8.44991 10.0655 8.56719 10.1828C8.68446 10.3001 8.75035 10.4591 8.75035 10.625C8.75035 10.7909 8.68446 10.9499 8.56719 11.0672L7.75859 11.875H16.25V3.75H7.5V4.375C7.5 4.54076 7.43415 4.69973 7.31694 4.81694C7.19973 4.93415 7.04076 5 6.875 5C6.70924 5 6.55027 4.93415 6.43306 4.81694C6.31585 4.69973 6.25 4.54076 6.25 4.375V3.75C6.25 3.41848 6.3817 3.10054 6.61612 2.86612C6.85054 2.6317 7.16848 2.5 7.5 2.5H16.25C16.5815 2.5 16.8995 2.6317 17.1339 2.86612C17.3683 3.10054 17.5 3.41848 17.5 3.75ZM13.125 15C12.9592 15 12.8003 15.0658 12.6831 15.1831C12.5658 15.3003 12.5 15.4592 12.5 15.625V16.25H3.75V8.125H12.2414L11.4328 8.93281C11.3155 9.05009 11.2497 9.20915 11.2497 9.375C11.2497 9.54085 11.3155 9.69991 11.4328 9.81719C11.5501 9.93446 11.7091 10.0003 11.875 10.0003C12.0409 10.0003 12.1999 9.93446 12.3172 9.81719L14.1922 7.94219C14.2503 7.88414 14.2964 7.81521 14.3279 7.73934C14.3593 7.66346 14.3755 7.58213 14.3755 7.5C14.3755 7.41787 14.3593 7.33654 14.3279 7.26066C14.2964 7.18479 14.2503 7.11586 14.1922 7.05781L12.3172 5.18281C12.1999 5.06554 12.0409 4.99965 11.875 4.99965C11.7091 4.99965 11.5501 5.06554 11.4328 5.18281C11.3155 5.30009 11.2497 5.45915 11.2497 5.625C11.2497 5.79085 11.3155 5.94991 11.4328 6.06719L12.2414 6.875H3.75C3.41848 6.875 3.10054 7.0067 2.86612 7.24112C2.6317 7.47554 2.5 7.79348 2.5 8.125V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H12.5C12.8315 17.5 13.1495 17.3683 13.3839 17.1339C13.6183 16.8995 13.75 16.5815 13.75 16.25V15.625C13.75 15.4592 13.6842 15.3003 13.5669 15.1831C13.4497 15.0658 13.2908 15 13.125 15Z" fill="#0B1215"/>
  </svg>
);

interface IPayoutPopoverOptionsProps {
  setOpen: Function;
  onClose: () => void;
  handleEdit: () => void;
  handleChange: () => void;
  handleDelete: () => void;
}

const PayoutPopoverOptions: React.FC<IPayoutPopoverOptionsProps> = ({
  setOpen,
  onClose,
  handleEdit,
  handleDelete,
  handleChange,
}) => {
  const iconClass = "w-5 h-5 text-darkBlack";

  const options = [
    {
      icon: <Edit20Regular className={iconClass} />,
      text: "Edit",
      action: () => {
        handleEdit();
      },
    },
    {
      icon: <ChangeIcon />,
      text: "Change",
      action: () => {
        handleChange();
      },
    },
    {
      icon: <Delete20Regular className={`w-5 h-5 text-coralRed`} />,
      text: "Delete",
      action: () => {
        handleDelete();
      },
    },
  ];

  return (
    <div className="flex flex-col">
      {options?.map((option) => {
        return (
          <div
            key={option?.text}
            className="cursor-pointer flex items-center gap-3 py-3 hover:bg-gray-50 transition-colors rounded"
            onClick={() => option?.action()}
          >
            {option?.icon}
            <span className={`font-poppins text-[14px] ${option?.text === "Delete" ? "text-coralRed" : "text-darkBlack"}`}>
              {option?.text}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default PayoutPopoverOptions;
